<template>
  <div class="tools">
    tools
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'ToolsView',
  components: {
  }
}
</script>
<style lang="scss" scoped>
.tools {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 5px;
}
</style>

